import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  root: {
    marginBottom: 15
  },
}))
